module.exports = __webpack_public_path__ + "img/websites.2bd162c1.png";